import { Typography, Box } from '@mui/material';
import config from 'config';
import { useNavigate } from 'react-router-dom';

const softColorMap = {
    warning: '#FFF4E6',   // TDK - Daha sıcak turuncu
    info: '#E0F2FE',      // TTK - Daha açık mavi
    secondary: '#F3E8FF', // ATAM - Yumuşak mor
    primary: '#E0E7FF',   // AKM - Açık indigo
    error: '#FEF2F2',     // YK - Açık kırmızı
};

const getSoftColor = (key) => softColorMap[key] || '#F9FAFB';

function DashboardAllInstListCard({ instCounts = [] }) {
    const navigate = useNavigate();
    const institutions = config.institutions || [];

    const mergedData = institutions
        .map((inst) => {
            const row = instCounts.find((x) => x.inst === inst.inst) || {};
            return {
                ...inst,
                finishedMeetingCount: row.finishedMeetingCount || 0,
                ongoingMeetingCount: row.ongoingMeetingCount || 0,
            };
        })
        .sort((a, b) => {
            // Önce YK en başta, diğerlerini kurum uzun adına göre alfabetik sırala
            const aPriority = a.inst === 'YK' ? 0 : 1;
            const bPriority = b.inst === 'YK' ? 0 : 1;

            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }

            return a.instLongName.localeCompare(b.instLongName, 'tr');
        });

    const handleCardClick = (inst) => {
        if (!inst) return;

        const pageType = inst === 'YK' ? '2' : '4';
        navigate(`/listMeeting/${pageType}?inst=${inst}`);
    };

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, minmax(0, 1fr))',
                    md: 'repeat(3, minmax(0, 1fr))',
                    lg: 'repeat(5, minmax(0, 1fr))',
                },
                gap: 1.5,
            }}
        >
            {mergedData.map((item) => (
                <Box
                    key={item.inst}
                    onClick={() => handleCardClick(item.inst)}
                    sx={{
                        backgroundColor: getSoftColor(item.color),
                        borderRadius: 2,
                        p: 1.5,
                        border: '1px solid rgba(148,163,184,0.35)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        minHeight: 92,
                        transition: 'all 0.2s ease',
                        cursor: 'pointer',
                        '&:hover': {
                            boxShadow: 3,
                            transform: 'translateY(-2px)',
                            borderColor: 'rgba(129,140,248,0.7)',
                        },
                    }}
                >
                    <Box sx={{ mb: 1 }}>
                        <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#111827', fontSize: 13 }}>
                            {item.instLongName}
                        </Typography>
                        <Typography variant="caption" sx={{ color: '#6B7280' }}>
                            {item.inst}
                        </Typography>
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 0.5 }}>
                        <Box>
                            <Typography variant="caption" sx={{ color: '#059669', fontWeight: 500 }}>
                                Tamamlanan
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#047857', fontWeight: 700 }}>
                                {item.finishedMeetingCount}
                            </Typography>
                        </Box>
                        <Box sx={{ textAlign: 'right' }}>
                            <Typography variant="caption" sx={{ color: '#D97706', fontWeight: 500 }}>
                                Devam Eden
                            </Typography>
                            <Typography variant="body2" sx={{ color: '#B45309', fontWeight: 700 }}>
                                {item.ongoingMeetingCount}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            ))}
        </Box>
    );
}

export default DashboardAllInstListCard;

